/* 
  This service regularly checks for biocore updates
*/

import { Plugin } from "plugin";


class UpdaterService extends Plugin {
  constructor(...args) {
    super(...args);
            
    //this.init();
  }/*
  async init() {
    console.log("checking for update");
    if (await this.#upgradable()) {
      console.info("jfermi upgadable");
    }
  }*/
  RM_upgrade_check(request) {    
    return new Promise(function(resolve, reject) {
      /* TODO: use relative path */
      var worker = new Worker("/usr/share/jfermi/services/service-update-worker.js");
      worker.postMessage("check");
      worker.onmessage = function(event) {
        resolve(event.data);
      };
    });    
  }      
}

export default UpdaterService;